import { is_dev_default, isFunction, use_latest_default } from './chunk-24OWA2BQ.mjs';
import { useEffect } from 'react';

var useUnmount = (fn) => {
  if (is_dev_default && !isFunction(fn)) {
    console.error(
      `useUnmount expected parameter is a function, got ${typeof fn}`
    );
  }
  const fnRef = use_latest_default(fn);
  useEffect(
    () => () => {
      fnRef.current();
    },
    []
  );
};
var use_unmount_default = useUnmount;

export { use_unmount_default };
